import React from 'react';
import {
  useCountryOfBusinessContext,
} from '@dataroom/country-of-business/CountryOfBusinessContext';
import AccessRequestStatuses from './AccessRequestStatuses';
import { ICellProps } from '@dealroadshow/uikit-table/DataTable';
import { IDataroomListItem } from '../../../../domain/vo/DataroomListItem';

interface IProps {
  cellProps: ICellProps<IDataroomListItem>,
  withSessionCheck?: boolean,
}

const AccessRequestStatusesWithCountryCheck = ({
  cellProps,
  withSessionCheck,
}: IProps) => {
  const { countryId: userCountryId } = useCountryOfBusinessContext();
  const dataroom = cellProps.row;
  const restrictedCountryIds = dataroom.restrictedCountryIds ?? [];
  const isRestrictedUser =
    userCountryId != null && restrictedCountryIds.includes(userCountryId);

  return (
    <AccessRequestStatuses
      cellProps={ cellProps }
      withSessionCheck={ withSessionCheck }
      isRestricted={ isRestrictedUser }
    />
  );
};

export default AccessRequestStatusesWithCountryCheck;
